<template>
  <div class="asset-vote">
    <div
      class="vote-form"
      v-if="!voteStart || !voteEnd || (voteStart <= now && now < voteEnd)"
    >
      <!-- <div
        class="f-group tips tips-red"
        v-if="periodTime&&currentRound=='b'"
      >{{$t('tips.canNotVote').replace('{d}',periodTime.next.start.toLocaleString())}}</div>-->
      <div
        class="f-group tips tips-red"
        v-if="periodTime && currentRound != 'b'"
      >
        {{
          $t("tips.mustVoteBeforeB").replace(
            "{d}",
            (voteEnd || periodTime.current.b).toLocaleString()
          )
        }}
      </div>
      <div class="f-group tips tips-red">{{ $t("tips.allVote") }}</div>
      <div class="f-group" v-if="currentRound">
        <div class="f-input">
          <div class="f-info f-info-round">
            <!-- <span>{{$t("superNode.current")}}{{$t("superNode.round"+currentRound)}}</span> -->
            <span
              >{{ $t("superNode.currentVote") }}{{ currentVote || "-" }}</span
            >
            <span v-if="nextRoundTime"
              >{{ $t("superNode.nextRoundTime")
              }}{{
                rewardStart
                  ? rewardStart.toLocaleString()
                  : nextRoundTime.toLocaleString()
              }}</span
            >
            <!-- <p class="p-title">Details:</p>
            <p class="p-con">XXXXXX</p>-->
          </div>
        </div>
      </div>

      <div class="f-group">
        <div class="f-title">{{ $t("asset.selectNode") }}</div>
        <div class="f-input">
          <Select
            class="select"
            :placeholder="$t('asset.selectNodePlaceholder')"
            @on-change="onNodeChange"
            v-model="userSelectedNode"
          >
            <Option
              :value="item.vote_id"
              v-for="item in nodeList.filter((it) => it.selfLock > 0)"
              v-bind:key="item.vote_id"
            >
              {{ item.witness_account_name }}
              <span
                class="self-lock"
                v-if="typeof item.selfLock != 'undefined'"
              >
                {{ $t("asset.selfLock") }}
                {{ formatToken(item.selfLock) }}
              </span>
            </Option>
          </Select>
        </div>
      </div>

      <div class="f-group">
        <div class="f-title">{{ $t("asset.nodeInformation") }}</div>
        <div class="f-input">
          <div class="f-info">
            <p class="p-title" v-if="selectedNodeSelfLock">
              {{ $t("asset.selfLock") }}
            </p>
            <p class="p-con" v-if="selectedNodeSelfLock">
              {{ formatToken(selectedNodeSelfLock) }}
            </p>

            <p class="p-title" v-if="selectedNodeIntro">
              {{ $t("superNode.teamIntroTitle") }}
            </p>
            <p class="p-con" v-if="selectedNodeIntro">
              {{ selectedNodeIntro }}
            </p>

            <p class="p-title" v-if="selectedNodePlan">
              {{ $t("superNode.buildingPlanTitle") }}
            </p>
            <p class="p-con" v-if="selectedNodePlan">{{ selectedNodePlan }}</p>

            <p class="p-title" v-if="selectedNodeRatio">
              {{ $t("superNode.dividendRatioTitle") }}
            </p>
            <p class="p-con" v-if="selectedNodeRatio">
              {{ selectedNodeRatio }}
            </p>

            <!-- <p class="p-title">Details:</p>
            <p class="p-con">XXXXXX</p>-->
          </div>
        </div>
      </div>

      <div class="f-group">
        <div class="f-btn">
          <div v-if="!canVote" class="btn disabled">
            {{ $t("asset.confirm") }}
          </div>
          <div v-if="canVote" class="btn" @click="onConfirmClick">
            {{ $t("asset.confirm") }}
          </div>
          <div class="btn-fee">
            {{ $t("asset.voteFee") }}{{ formatToken(fee) }} +
            {{ formatToken(price_per_kbyte) }} {{ $t("asset.feePerKb") }}
          </div>
        </div>
      </div>
      <dna-spin v-if="isLoading"></dna-spin>
      <!-- 输入密码 -->
      <dna-password-modal
        :isShow="isPasswordModalShow"
        @closed="isPasswordModalShow = false"
        @confirm="onPasswordConfirm"
      ></dna-password-modal>
    </div>
    <div
      class="vote-form"
      v-if="voteStart && voteEnd && (now < voteStart || voteEnd < now)"
    >
      <div class="tips tips-red" v-if="now < voteStart">
        {{ $t("tips.voteStartAt").replace("{d}", voteStart.toLocaleString()) }}
      </div>
      <div class="tips tips-red" v-if="voteEnd < now">
        {{ $t("tips.voteEndAt").replace("{d}", voteEnd.toLocaleString()) }}
      </div>
      <div class="f-group" v-if="currentRound && voteEnd < now">
        <div class="f-input">
          <div class="f-info f-info-round">
            <!-- <span>{{$t("superNode.current")}}{{$t("superNode.round"+currentRound)}}</span> -->
            <span
              >{{ $t("superNode.currentVote") }}{{ currentVote || "-" }}</span
            >
            <span v-if="nextRoundTime"
              >{{ $t("superNode.nextRoundTime")
              }}{{
                rewardStart
                  ? rewardStart.toLocaleString()
                  : nextRoundTime.toLocaleString()
              }}</span
            >
            <!-- <p class="p-title">Details:</p>
            <p class="p-con">XXXXXX</p>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wsSubscribe from "@/req/wsSubscribe.js";
import tx from "@/req/tx.js";
import req from "@/req/req.js";
import wallet from "@/util/wallet.js";
import UTIL from "@/util/util.js";
import ERROR from "@/util/error.js";
import DATA from "@/data/data.js";
import BigNumber from "bignumber.js";

export default {
  // 参数
  data() {
    let that = this;
    return {
      //temp
      // voteStart: new Date("Thu Sep 26 2020 21:00:00 GMT+0800"),
      // voteEnd: new Date("Thu Sep 30 2020 21:00:00 GMT+0800"),
      // rewardStart: new Date("Thu Oct 08 2020 21:00:00 GMT+0800"),
      //11th vote
      voteStart: new Date("Sun Nov 29 2020 21:00:00 GMT+0800"), //console.log(new Date("2020-11-29 21:00:00"));
      voteEnd: new Date("Thu Dec 03 2020 21:00:00 GMT+0800"),//console.log(new Date("2020-12-03 21:00:00"));
      rewardStart: new Date("Fri Dec 11 2020 21:00:00 GMT+0800"),//console.log(new Date("2020-12-11 21:00:00"));
      now: new Date(),
      //recipient: "",
      isLoading: true,
      isPasswordModalShow: false,
      currentRound: "",
      symbol: DATA.TOKEN_SYMBOL,
      //currentVoteIds: [],
      currentVote: "",
      nextRoundTime: null,
      era_round: 1,
      canVote: false,
      timeInterval: 0,
      userSelectedNode: this.selectedNode,
      selectedNodeIntro: "",
      selectedNodePlan: "",
      selectedNodeSelfLock: 0,
      selectedNodeRatio: "", //TODO
      nodeList: [],
      fee: 0,
      price_per_kbyte: 0,
      tx_kbyte: 0,
      periodTime: null,
    };
  },
  async mounted() {
    let that = this;
    setInterval(() => {
      that.now = new Date();
    }, 1000);
    await that.load();
    setTimeout(() => {
      let logNodes = that.nodeList
        .filter((it) => it.selfLock > 0)
        .map((item) => {
          return {
            name: item.witness_account_name,
            selfLock: that.formatToken(item.selfLock),
          };
        });
      console.log(JSON.stringify(logNodes));
      console.log("nodes length:" + logNodes.length);
    }, 5000);
  },
  methods: {
    load() {
      //获取可用余额
      let that = this;
      if (!that.address) {
        that.$router.push("/").catch((err) => {});
        return;
      }
      async function doLoad() {
        await that.loadWitnesses();
        await that.loadWitnessesVesting();
        await that.loadWitnessInfo();
        await that.loadRound();
        await that.loadTime();
        await that.loadFee();
        return true;
      }
      doLoad()
        .then((res) => {
          that.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          that.isLoading = false;
          let msg = that.$t("global.networkError");
          that.$Message.error({
            background: true,
            duration: 5,
            content: msg,
          });
        });
    },

    async loadFee() {
      let that = this;
      let feeResults = await wsSubscribe.wsFetchOperationFees([
        "account_update",
      ]);
      //console.log(feeResults);
      if (feeResults.length) {
        that.fee = feeResults[0].fee;
        that.price_per_kbyte = feeResults[0].price_per_kbyte;
      }
    },
    formatToken(val) {
      return UTIL.formatToken(val, [], 4); //
    },
    formatTokenWithoutSymbol(val) {
      return UTIL.formatToken(val, [], 4, ""); //
    },
    onNodeChange(val) {
      let that = this;
      that.userSelectedNode = val;
      setImmediate(async function () {
        await that.loadWitnessInfo();
      });
    },
    onConfirmClick() {
      let that = this;

      if (!that.userSelectedNode) {
        that.isLoading = false;
        that.$Message.error({
          background: true,
          duration: 5,
          content: that.$t("asset.voteNodeException"),
        });
        return;
      }
      let node = that.nodeList.find(
        (it) => it.vote_id == that.userSelectedNode
      );
      let minLocked = UTIL.toUnit(DATA.witnessMinLocked);
      //alert(node.selfLock);
      if (!node.selfLock || BigNumber(node.selfLock).isLessThan(minLocked)) {
        that.$Message.error({
          background: true,
          duration: 5,
          content: that.$t("asset.voteNodeMinLock", {
            m: that.formatToken(minLocked),
          }),
        });
        return;
      }
      this.isPasswordModalShow = true;
    },
    async onPasswordConfirm(pwd) {
      let that = this;
      try {
        that.isPasswordModalShow = false;

        let userInfo = that.$store.state.userInfo;
        let mnemonic = UTIL.decryptKey(userInfo.key, pwd);
        if (!mnemonic) {
          that.isLoading = false;
          that.$Message.error({
            background: true,
            duration: 5,
            content: that.$t("global.passwordError"),
          });
          return;
        }
        if (!that.userSelectedNode) {
          that.isLoading = false;
          that.$Message.error({
            background: true,
            duration: 5,
            content: that.$t("asset.voteNodeException"),
          });
          return;
        }

        that.isLoading = true;
        if (that.net == "bts") {
          // BTS网络下，查询该ID对应信息
          let walletInfo = wallet.getAccountInfo(mnemonic, that.net);
          let voteList = this.nodeList.filter(
            (it) => it.vote_id == that.userSelectedNode
          );
          let voteResult = await tx.voteForWitness(
            walletInfo.privateKey,
            userInfo.name,
            voteList,
            ""
          );
          let txId = voteResult && voteResult.length ? voteResult[0].id : "";
          that.$Message.success({
            background: true,
            duration: 3,
            content: that.$t("asset.voteSuccess") + " " + txId,
          });
          that.$store.commit("setSelectedNode", that.userSelectedNode);
          that.load();
        }
        if (that.net == "sub") {
          // SUB网络，直接存储
        }
        this.isLoading = false;
        return;
      } catch (err) {
        that.isLoading = false;
        let msg =
          ERROR.getCustomMessage(err, that.$t.bind(that)) ||
          that.$t("global.networkError");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg,
        });
      }
    },
    async loadWitnesses() {
      let that = this;
      var witnesses = await wsSubscribe.wsFetchAllWitness();
      //console.log(JSON.stringify(witnesses));
      that.nodeList = witnesses;
      let accountInfo = await wsSubscribe.wsFetchBtsGetAccountDetail(
        that.address
      );
      if (accountInfo && accountInfo.length) {
        accountInfo = accountInfo[0];
        let votes = accountInfo.options.votes;
        if (votes.length) {
          let vote_id = votes[0][0];
          that.userSelectedNode = vote_id;
          that.$store.commit("setSelectedNode", vote_id);
          let curr = witnesses.find((it) => it.vote_id == vote_id);
          that.currentVote = curr ? curr.witness_account_name : "";
        }
      }
      // console.log(witnesses);
      return witnesses;
    },
    sortWitness() {
      let that = this;
      that.nodeList = that.nodeList.sort((a, b) => {
        // if (new BigNumber(a.total_votes).isEqualTo(b.total_votes)) {
        //   return new BigNumber(a.selfLock).isLessThan(
        //     b.selfLock
        //   )
        //     ? 1
        //     : -1;
        // } else {
        //   return new BigNumber(a.total_votes).isLessThan(b.total_votes) ? 1 : -1;
        // }
        if (new BigNumber(a.selfLock).isEqualTo(b.selfLock)) {
          return new BigNumber(a.total_votes).isLessThan(b.total_votes)
            ? 1
            : -1;
        } else {
          return new BigNumber(a.selfLock).isLessThan(b.selfLock) ? 1 : -1;
        }
      });
    },
    async loadWitnessesVesting() {
      let that = this;
      for (var i = 0; i < that.nodeList.length; i++) {
        _load(that.nodeList[i])
          .then((res) => {
            that.sortWitness();
          })
          .catch((err) => {
            console.log(err);
          });
      }
      async function _load(node) {
        let vestingBalances = await wsSubscribe.wsGetVestingBalances(
          node.witness_account
        );
        vestingBalances = vestingBalances.filter(
          (it) => it.balance_type == "governance" && it.policy[0] == 3
        );
        let totalLock = BigNumber(0);
        vestingBalances.forEach((item, index) => {
          totalLock = totalLock.plus(item.balance.amount);
        });
        node.selfLock = totalLock.toString();
        if (node.vote_id == that.userSelectedNode) {
          that.selectedNodeSelfLock = node.selfLock;
          // console.log(JSON.stringify(nodeInfo));
        }
        return true;
      }
    },
    async loadWitnessInfo() {
      let that = this;
      that.selectedNodeIntro = "";
      that.selectedNodePlan = "";
      that.selectedNodeRatio = "";
      if (that.userSelectedNode) {
        let w = that.nodeList.find((it) => it.vote_id == that.userSelectedNode);
        if (w && w.witness_account_name) {
          let nodeInfo = await req.fetchTargetNodeInfo(w.witness_account_name);
          that.selectedNodeIntro = nodeInfo ? nodeInfo.introduction : "";
          that.selectedNodePlan = nodeInfo ? nodeInfo.plan : "";
          // console.log(JSON.stringify(nodeInfo));
        }
        if (w) {
          that.selectedNodeSelfLock = w.selfLock;
          let currentRatio = w.block_producer_reward_pct / 100;
          let nextRatio = w.next_block_producer_reward_pct / 100;
          let ratio =
            that.$t("superNode.currentRatio") + currentRatio.toFixed(2) + "%";
          if (nextRatio != currentRatio) {
            ratio +=
              "   " +
              that.$t("superNode.nextRatio") +
              nextRatio.toFixed(2) +
              "%";
          }
          that.selectedNodeRatio = ratio;
        }
      }
    },
    async loadRound() {
      let that = this;
      let round = await wsSubscribe.wsFetchVotingPeriod();
      that.currentRound = round;
      if (round == "pre" || round == "a") {
        that.canVote = true;
      }
    },
    async loadTime() {
      let that = this;
      let properties = await wsSubscribe.wsFetchGlobalProperites();
      if (properties && properties.next_era_start_time) {
        that.nextRoundTime = new Date(properties.next_era_start_time + "Z");
        that.era_round = properties.era_round;

        var newbasedateTime = UTIL.getnewdata(new Date(DATA.strbaseBlockChainStartTime),  (that.era_round - 1) *64);
        that.voteStart = UTIL.getnewdata(newbasedateTime, 52);
        that.voteEnd = UTIL.getnewdata(newbasedateTime, 56);

        let round1 = new Date("Thu Oct 08 2020 21:00:00 GMT+0800");
        // if (that.nextRoundTime < round1) {
        //   //TODO:temp fix bug of round 1, 2020-10-05;
        //   that.nextRoundTime = round1;
        // }
        that.periodTime = UTIL.culPeriod(that.nextRoundTime);
        console.log(JSON.stringify(that.periodTime));
        clearInterval(that.timeInterval);
        that.timeInterval = setInterval(() => {
          if (that.nextRoundTime && new Date() >= that.nextRoundTime) {
            clearInterval(that.timeInterval);
            that.load();
          }
        }, 10000);
      }
    },
  },
  computed: {
    net() {
      return this.$store.state.net;
    },
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    },
    selectedNode() {
      return this.$store.state.userInfo.selectedNode;
    },
    availableBalance() {
      let balances = this.$store.state.userInfo.balances || [];
      let coreAsset = balances.find(
        (it) => it.asset_type == DATA.TOKEN_ASSET_ID
      );
      if (coreAsset) {
        return coreAsset.balance;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./AssetVoteForm.less");
</style>